// extracted by mini-css-extract-plugin
export default {"scrollTopGuide":"scrollTopGuide__Rzqe0","scrollBottomGuide":"scrollBottomGuide__L0wtO"};